import {css, StyleSheet} from 'aphrodite';
import React, {CSSProperties} from 'react';

import {GRAY_SEMIDARK} from 'ui-library/Colors';
import Tooltip from 'ui-library/floating-ui/Tooltip';

export interface AlignmentBoxAndWhiskersProps {
  // Higher components does the translating from number of pairs and zoom level to pixels
  // When zoomed in, the component will be larger than the actual spot in the table component,
  boxStart: number;
  boxEnd: number;
  totalLength: number;
  color: string;
  alignmentScore: number;
  enableTooltip: boolean;
}

export function AlignmentBoxAndWhiskers(props: AlignmentBoxAndWhiskersProps): JSX.Element {
  const leftHorizontalStyle: CSSProperties = {
    width: `${props.boxStart}px`,
  };

  const rectStyle: CSSProperties = {
    width: `${props.boxEnd - props.boxStart}px`,
    background: props.color,
  };

  const rightHorizontalStyle: CSSProperties = {
    width: `${props.totalLength - props.boxEnd}px`,
  };

  const displayLeftBar = props.boxStart > 0;
  const displayRightBar = props.boxEnd < props.totalLength;

  return (
    <div className={css(styles.row)}>
      {displayLeftBar && <div className={css(styles.vertLine)} />}
      <div className={css(styles.horizontal)} style={leftHorizontalStyle} />
      <Tooltip text={`Alignment score: ${props.alignmentScore}`} isDisabled={!props.enableTooltip}>
        <div className={css(styles.rect)} style={rectStyle} />
      </Tooltip>
      <div className={css(styles.horizontal)} style={rightHorizontalStyle} />
      {displayRightBar && <div className={css(styles.vertLine)} />}
    </div>
  );
}

const styles = StyleSheet.create({
  row: {
    display: 'flex',
  },
  rect: {
    height: '9px',
    border: `1px solid ${GRAY_SEMIDARK}`,
  },
  horizontal: {
    height: '0px',
    marginTop: '4px',
    borderBottom: `1px solid ${GRAY_SEMIDARK}`,
  },
  vertLine: {
    width: '0px',
    height: '9px',
    borderRight: `1px solid ${GRAY_SEMIDARK}`,
  },
});
